import { motion } from 'framer-motion';
import { useMeCore } from '../../../core/modules/me';
// import { useCompanyCore } from '../../../core/modules/company';
// import { useEffect, useMemo } from 'react';
import {
  // Grid,
  // Card,
  // CardContent,
  Typography,
  Box,
  Paper,
  Avatar,
  // IconButton,
  // Chip,
} from '@mui/material';
// import {
//   TrendingUp,
//   TrendingDown,
//   Inventory,
//   AttachMoney,
//   ShoppingCart,
//   StoreMallDirectory,
//   CalendarToday,
// } from '@mui/icons-material';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
// } from 'chart.js';
// import { Line, Bar, Doughnut } from 'react-chartjs-2';

// Registrar los componentes de Chart.js
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement
// );

function Welcome() {
  const { user } = useMeCore();
  // const { getCompanies } = useCompanyCore();

  // useEffect(() => {
  //   if (user?.privileges.superAdmin) {
  //     getCompanies({});
  //   }
  // }, [getCompanies, user?.privileges.superAdmin]);

  // Datos mock para los gráficos y métricas
  // const dashboardData = useMemo(() => {
  //   const currentDate = new Date();
  //   const currentMonth = currentDate.toLocaleDateString('es-ES', {
  //     month: 'long',
  //     year: 'numeric',
  //   });
  //   const previousMonth = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth() - 1,
  //     1
  //   ).toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });

  //   return {
  //     currentMonth,
  //     previousMonth,
  //     totalStock: {
  //       amount: 2456789,
  //       quantity: 15847,
  //     },
  //     averageProfitability: 23.5,
  //     currentMonthSales: {
  //       total: 456789,
  //       profitability: 24.2,
  //     },
  //     previousMonthSales: {
  //       total: 398567,
  //       profitability: 22.8,
  //     },
  //     // Datos para gráfico de ventas de los últimos 6 meses
  //     salesData: {
  //       labels: [
  //         'Julio',
  //         'Agosto',
  //         'Septiembre',
  //         'Octubre',
  //         'Noviembre',
  //         'Diciembre',
  //       ],
  //       mayorista: [320000, 345000, 380000, 395000, 412000, 456000],
  //       ecommerce: [125000, 138000, 142000, 156000, 168000, 189000],
  //     },
  //     // Datos para gráfico de rentabilidad
  //     profitabilityData: [18.5, 20.2, 22.1, 21.8, 23.1, 24.2],
  //   };
  // }, []);

  // Configuración del gráfico de ventas
  // const salesChartData = {
  //   labels: dashboardData.salesData.labels,
  //   datasets: [
  //     {
  //       label: 'Mayorista',
  //       data: dashboardData.salesData.mayorista,
  //       backgroundColor: 'rgba(25, 118, 210, 0.1)',
  //       borderColor: 'rgba(25, 118, 210, 1)',
  //       borderWidth: 3,
  //       fill: true,
  //       tension: 0.4,
  //     },
  //     {
  //       label: 'Ecommerce',
  //       data: dashboardData.salesData.ecommerce,
  //       backgroundColor: 'rgba(76, 175, 80, 0.1)',
  //       borderColor: 'rgba(76, 175, 80, 1)',
  //       borderWidth: 3,
  //       fill: true,
  //       tension: 0.4,
  //     },
  //   ],
  // };

  // Configuración del gráfico de rentabilidad
  // const profitabilityChartData = {
  //   labels: dashboardData.salesData.labels,
  //   datasets: [
  //     {
  //       label: 'Rentabilidad (%)',
  //       data: dashboardData.profitabilityData,
  //       backgroundColor: [
  //         'rgba(255, 193, 7, 0.8)',
  //         'rgba(255, 152, 0, 0.8)',
  //         'rgba(255, 87, 34, 0.8)',
  //         'rgba(233, 30, 99, 0.8)',
  //         'rgba(156, 39, 176, 0.8)',
  //         'rgba(103, 58, 183, 0.8)',
  //       ],
  //       borderColor: [
  //         'rgba(255, 193, 7, 1)',
  //         'rgba(255, 152, 0, 1)',
  //         'rgba(255, 87, 34, 1)',
  //         'rgba(233, 30, 99, 1)',
  //         'rgba(156, 39, 176, 1)',
  //         'rgba(103, 58, 183, 1)',
  //       ],
  //       borderWidth: 2,
  //     },
  //   ],
  // };

  // Configuración del gráfico de distribución de ventas
  // const distributionChartData = {
  //   labels: ['Mayorista', 'Ecommerce'],
  //   datasets: [
  //     {
  //       data: [
  //         dashboardData.salesData.mayorista.reduce((a, b) => a + b, 0),
  //         dashboardData.salesData.ecommerce.reduce((a, b) => a + b, 0),
  //       ],
  //       backgroundColor: ['rgba(25, 118, 210, 0.8)', 'rgba(76, 175, 80, 0.8)'],
  //       borderColor: ['rgba(25, 118, 210, 1)', 'rgba(76, 175, 80, 1)'],
  //       borderWidth: 2,
  //     },
  //   ],
  // };

  // const chartOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     legend: {
  //       position: 'top' as const,
  //     },
  //   },
  //   scales: {
  //     y: {
  //       beginAtZero: true,
  //       ticks: {
  //         callback: function (value: any) {
  //           return '$' + value.toLocaleString();
  //         },
  //       },
  //     },
  //   },
  // };

  // const barChartOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     legend: {
  //       position: 'top' as const,
  //     },
  //   },
  //   scales: {
  //     y: {
  //       beginAtZero: true,
  //       max: 30,
  //       ticks: {
  //         callback: function (value: any) {
  //           return value + '%';
  //         },
  //       },
  //     },
  //   },
  // };

  // const doughnutOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     legend: {
  //       position: 'bottom' as const,
  //     },
  //   },
  // };

  // const formatCurrency = (amount: number) => {
  //   return new Intl.NumberFormat('es-CL', {
  //     style: 'currency',
  //     currency: 'CLP',
  //     minimumFractionDigits: 0,
  //   }).format(amount);
  // };

  // const formatNumber = (number: number) => {
  //   return new Intl.NumberFormat('es-CL').format(number);
  // };

  return (
    <Box
      className="flex flex-col flex-1 p-16"
      sx={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}
    >
      {/* Header */}
        <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-24"
      >
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar
              src="/assets/images/logo/Logo Revaluex.png"
              sx={{ width: 60, height: 60 }}
            />
            <Box>
              <Typography variant="h4" color="white" fontWeight="bold">
                Hola {user?.name} 👋
              </Typography>
              <Typography variant="h6" color="rgba(255,255,255,0.8)">
                Panel de Control -{' '}
                {new Date().toLocaleDateString('es-ES', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </motion.div>

      {/* Cards de Métricas - COMENTADO TEMPORALMENTE */}
      {/* <Grid container spacing={3} className="mb-24">
        // ... existing code ...
      </Grid> */}

      {/* Gráficos - COMENTADO TEMPORALMENTE */}
      {/* <Grid container spacing={3}>
        // ... existing code ...
      </Grid> */}
    </Box>
  );
}

export default Welcome;
